
import Footer from "../Footer.jsx";
import Synthetix from "../Synthetix.jsx"

import "../../css/styles.css";

import LoginAndPWReset from "../LoginAndPWReset/LoginAndPWReset.js";
import { TwoSwitch } from "../../lib/iprs-react-library/src/index.js";
import AddReferrer from "../AddReferrer/AddReferrer.js";
import IprsHealthPortal from "./IprsHealthPortal/IprsHealthPortal.jsx";

const App = ({ api, urlPath, urlToken }) => {
    
    const doAddReferrer = (/AddReferrer.*/i).test(urlPath)
    return (
        <>
            <LoginAndPWReset api={api} urlPath={urlPath} urlToken={urlToken}>
                <TwoSwitch test={doAddReferrer} >
                    <AddReferrer api={api} urlToken={urlToken} urlPath={urlPath} />
                    <IprsHealthPortal api={api}/>
                </TwoSwitch>
            </LoginAndPWReset>
            <Footer />
            <Synthetix />
        </>
    );
};

// Special treatment - See WR-472
const AEROMED_MITIE_HOLDING_ROOMS_CLIENT_ID = 212654;

export {AEROMED_MITIE_HOLDING_ROOMS_CLIENT_ID};
export default App;
